/* jshint esversion: 6 */
import React from 'react';
import * as _ from 'underscore';

export default function PersistData(Component) {

    class PersistData extends React.Component {
        constructor(props) {
            super(props);

            this.persistData = this.persistData.bind(this);
            this.getPersistedData = this.getPersistedData.bind(this);
            this.restorePeristedData = this.restorePeristedData.bind(this);
            this.clearPersistedData = this.clearPersistedData.bind(this);

        }

        persistData(key, state) {
            if (!key) {
                return;
            }

    		if (typeof(Storage) !== undefined) {
    			window.localStorage.setItem(key, JSON.stringify(state));

    		} else {
                let domain = this.props.app.config.cookieDomain,
                    expiration = new Date(new Date().getTime() + (30 * 60 * 1000)).toGMTString();

                window.document.cookie = `${key}=${encodeURIComponent(JSON.stringify(state))}; expires=${expiration}; path=/; domain=${domain};`;

    		}
    	}

        getPersistedData(key) {
            var data = null;

            if (typeof(Storage) !== undefined) {
    			// check for stored state and assign
                // make sure it's not undefined first
                // then check to make sure it's not falsy
                // checking together is letting undefined or null through
                if (window.localStorage[key] === undefined) {
                    return data;
                }
                if (window.localStorage[key] !== null) {
                    try {
                        data = JSON.parse(window.localStorage[key]);
                    } catch (e) {
                        return data;
                    }
                }
    			
    		} else {
                var entries = window.document.cookie.split(";");
    			for (var i = 0; i < entries.length; ++i) {
    				if (entries[i].match(key)) {
    					var cookieData = entries[i].split("=");
                        if (cookieData.length && cookieData[1] !== undefined && cookieData[1] !== null) {
                            data = JSON.parse(decodeURIComponent(cookieData[1]));
                        }
    					break;
    				}
    			}
            }

            return data;
        }

        restorePeristedData(key, callback, component) {
            var data = this.getPersistedData(key);

            if (data) {
                if (_.isFunction(callback)) {
                    callback.apply(component, [data]);
                }
                component.setState(data);
            }

        }

        clearPersistedData(key) {

            if (typeof(Storage) !== undefined) {
                if (window.localStorage[key]) {
                    window.localStorage.removeItem(key);
                }
            } else {
                let domain = this.props.app.config.cookieDomain,
                    expiration = new Date(0).toGMTString();

                window.document.cookie = `${key}=''; expires=${expiration}; path=/; domain=${domain};`;
            }
        }

        render() {
            return (
                <Component
                    {...this.props}
                    persistData={this.persistData}
                    getPersistedData={this.getPersistedData}
                    restorePeristedData={this.restorePeristedData}
                    clearPersistedData={this.clearPersistedData}/>
            );
        }

    }

    PersistData.displayName = "PersistData";

    return PersistData;

}
